import React from 'react';
import PropTypes from 'prop-types';

import get from 'utils/get';
import cx from 'classnames';
import slugify from 'utils/slugify';

const BlockQuote = ({ block }) => {
  const fields = get(block, 'fields', {});
  const title = get(fields, 'title', '');
  const quote = get(fields, 'quote', '');
  const quotee = get(fields, 'quotee', '');
  const paddingTop = slugify(get(fields, 'paddingTop', 'Large'));
  const paddingBottom = slugify(get(fields, 'paddingBottom', 'Large'));
  const showBlockTitle = get(fields, 'showBlockTitle', false);

  return (
    <div
      className={cx(
        `relative px2_5 padding-top-${paddingTop} padding-bottom-${paddingBottom} block-width mxauto`,
        { guideline: showBlockTitle }
      )}
    >
      {showBlockTitle ? (
        <p className="block-title absolute r0 t0">{title}</p>
      ) : null}
      <div className="flex justify-center">
        <div className="md:pr4 inline-block">
          {quote && (
            <p className="BlockQuote__quote color-gold-brown">{quote}</p>
          )}
          {quotee && <p className="BlockQuote__quotee">{quotee}</p>}
        </div>
      </div>
    </div>
  );
};

BlockQuote.propTypes = {
  block: PropTypes.shape({
    fields: PropTypes.shape({
      quote: PropTypes.string,
      quotee: PropTypes.string,
      paddingTop: PropTypes.string,
      paddingBottom: PropTypes.string,
      title: PropTypes.string,
      showBlockTitle: PropTypes.bool
    })
  })
};

BlockQuote.defaultProps = {
  block: {
    fields: {
      quote: '',
      quotee: '',
      paddingTop: 'Large',
      paddingBottom: 'Large',
      title: '',
      showBlockTitle: false
    }
  }
};

export default BlockQuote;
